import { lazy, Suspense } from "react";
import "aos/dist/aos.css";
import HeroSection from "./Homepage/banner";
import BingoldInfo from "./Homepage/aboutUs";
import Service from "./Homepage/Service";

const WhyChooseBingold = lazy(() => import("./Homepage/whyChooseBingold"));
const UseCases = lazy(() => import("./Homepage/useCases"));
const Tokenomics = lazy(() => import("./Homepage/Tokenomics"));
const Roadmap = lazy(() => import("./Homepage/roadmap"));
const BuyBigod = lazy(() => import("./Homepage/buyBigod"));
const FaqAccordion = lazy(() => import("./Homepage/faq"));
const TokenAnime = lazy(() => import("./Homepage/tokenAnime"));
const GoldAllocationLookup = lazy(() => import("./Homepage/GoldAllocationLookup"));
const VideoPlayer = lazy(() => import("./Homepage/videoPlayer"));
const OurPartner = lazy(() => import("./Homepage/ourPartner"));
const BlogCards = lazy(() => import("./Homepage/blog"));
const SimilarNews = lazy(() => import("./Homepage/news"));
const AgentVerification = lazy(() => import("./Homepage/AgentVerification"));

const SectionFallback = () => <div style={{ minHeight: "300px" }} />;

const Home = () => {
  return (
    <>
      {/* Page Content */}
      <div className="flex flex-col md:gap-20 gap-14">
        <HeroSection />
        <div id="about" className="scroll-mt-28">
          <BingoldInfo />
        </div>

        <Suspense fallback={<SectionFallback />}>
          <WhyChooseBingold />
          
          <Service />
          <UseCases />
          <OurPartner />

          <div id="tokenomics" className="scroll-mt-28">
            <Tokenomics />
          </div>

          <section className="flex justify-center items-center py-10 bg-gray-50 dark:bg-gray-900 rounded-xl shadow-md w-full max-w-xs mx-auto">
            <iframe
              src="https://app.rwa.io/embed/verification-project-badge/bingold?theme=light"
              width="190"
              height="70"
              loading="lazy"
              className="rounded-md"
              title="RWA Verification Badge"
            ></iframe>
          </section>

          <div id="roadmap" className="scroll-mt-28">
            <Roadmap />
          </div>

          <BuyBigod />

          <div id="faq" className="scroll-mt-28">
            <FaqAccordion />
          </div>

          <GoldAllocationLookup />
          <div id="agent-verification" className="scroll-mt-28">
            <AgentVerification />
          </div>
          <BlogCards />
          
          <SimilarNews />
          <VideoPlayer />
          <TokenAnime />
        </Suspense>
      </div>
    </>
  );
};

export default Home;
